import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import Icon from '../../components/AppIcon';

import BetaOpportunityItem from '../discover/betaOpportunityItem';

import { updateReadingList } from '../../modules/book';
import {useDispatch, useSelector} from '../../reduxHooks';
import { authUtil } from 'src/utils';

const EmptyState = styled.section`
  display: grid;
  min-height: min(440px, calc(100vh - 180px));
  place-items: center;
  padding: 32px 20px 96px;
  color: ${({ theme }) => theme.font.primary};
  text-align: center;
`;

const EmptyStateContent = styled.div`
  display: grid;
  max-width: 320px;
  justify-items: center;
  gap: 14px;

  > .icon {
    margin: 0 !important;
    color: ${({ theme }) => theme.navigation.accent};
    font-size: 38px;
  }

  > h2 {
    margin: 0;
    font-size: 20px;
  }
`;

const DiscoverButton = styled.button`
  min-height: 44px;
  padding: 10px 18px;
  border: 1px solid ${({ theme }) => theme.navigation.accent};
  border-radius: 999px;
  background: ${({ theme }) => theme.navigation.tabActiveBackground};
  color: ${({ theme }) => theme.navigation.tabActiveText};
  cursor: pointer;
  font: inherit;
  font-weight: 700;

  &:focus-visible {
    outline: 3px solid ${({ theme }) => theme.navigation.focus};
    outline-offset: 2px;
  }
`;

const ReadingList: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();

  const userProfile = useSelector((state: any) => state.user.userProfile);
  const reading = useSelector((state: any) => state.book.reading);

  const fetchReadingList = async () => {
    const idToken = await authUtil.getFreshIdToken();
    if (idToken) {
      dispatch(updateReadingList(idToken));
    }
  };

  useEffect(() => {
    fetchReadingList();
  }, []);

  if (userProfile === undefined || reading === undefined) {
    return <div role="status">{t('Loading', 'Loading…')}</div>;
  }
  return (
    <div
      id="reading-list"
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '10px 10px 0px 10px',
      }}
    >
      {reading.length > 0 ? (
        reading.map((book: any) => (
          <BetaOpportunityItem
            key={book._id}
            book={book}
            descriptionMaxLength={500}
            showLeaveOption
          />
        ))
      ) : (
        <EmptyState data-testid="reading-list-empty">
          <EmptyStateContent>
            <Icon name="bookmark" className="icon" aria-hidden="true" />
            <h2>{t('EmptyLibrary')}</h2>
            <DiscoverButton
              type="button"
              onClick={() => history.push('/discover')}
            >
              {t('Discover')}
            </DiscoverButton>
          </EmptyStateContent>
        </EmptyState>
      )}
    </div>
  );
};

export default ReadingList;
